/**
 * Which display refresh family a measured frame rate belongs to: 25/50 fps
 * content wants a 50 Hz output, 30/60 fps a 60 Hz one. The tolerance absorbs
 * measuring over a ten-second window and 59.94-style rates, yet keeps 24p film
 * (which neither family shows evenly) out. That, a stalled player or anything
 * else gets no opinion.
 */
export function refreshFamily(fps: number): 50 | 60 | null {
  if (!Number.isFinite(fps) || fps <= 0) return null;
  const near = (target: number) => Math.abs(fps - target) <= target * 0.03;
  if (near(50) || near(25)) return 50;
  if (near(60) || near(30)) return 60;
  return null;
}
